import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml, SafeUrl } from '@angular/platform-browser';

@Pipe({
  name: 'trusthtml',
  pure: true,
})
export class TrustHtmlPipe implements PipeTransform {
  constructor (private sanitizer: DomSanitizer) { }

  transform(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}

@Pipe({
  name: 'trusturl',
  pure: true,
})
export class TrustUrlPipe implements PipeTransform {
  constructor (private sanitizer: DomSanitizer) { }

  transform(url: string): SafeUrl {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }
}
